module.exports = __webpack_public_path__ + "static/media/loading-bar-backing.888eabf2.png";